import Hero from "./components/Hero";
import Services from "./components/Services";
import AboutSection from "./components/AboutSection";

import { useEffect } from "react";
import opInScreen from "./components/functions/opInScreen";
import Reviews from "./components/Reviews";
import MainLayout from "./components/MainLayout";

function Home() {
	useEffect(() => {
		opInScreen();
	});

	return (
		<MainLayout color={undefined} page="home">
			<Hero />
			<Services />
			<AboutSection />
			<Reviews />
		</MainLayout>
	);
}

export default Home;
